<template>
  <RouterView />
  <ModalContainer>
    <template #overlay>
      <div :class="$style.modalOverlay"></div>
    </template>
  </ModalContainer>
  <SnackContainer />
</template>

<script setup lang="ts">
import "vue-haystack/style.css";

import { ModalContainer } from "vue-haystack";

import SnackContainer from "@/components/SnackContainer.vue";
</script>

<style lang="scss" module>
.modalOverlay {
  width: 100%;
  height: 100%;
  background-color: #1c1c1c;
  opacity: 0.5;
}
</style>
